module.exports = __webpack_public_path__ + "img/browse.89e1565f.png";